import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Sistema de afiliados/referidos: los links tipo /RefFC etiquetan los leads con el
// código del afiliado. La atribución es PERMANENTE (se guarda en localStorage): una vez
// que alguien llega por un link de referido, queda asociado a ese afiliado.
const STORAGE_KEY = "mfs_ref";
const ReferralContext = createContext({ ref: null });

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

export const ReferralProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [ref, setRef] = useState(readStored);

  useEffect(() => {
    const m = pathname.match(/^\/ref([a-z0-9]+)/i);
    if (m) {
      const code = m[1].toUpperCase();
      try {
        localStorage.setItem(STORAGE_KEY, code);
      } catch {
        /* ignore */
      }
      setRef(code);
    }
  }, [pathname]);

  return <ReferralContext.Provider value={{ ref }}>{children}</ReferralContext.Provider>;
};

export const useReferral = () => useContext(ReferralContext);
